import { render, staticRenderFns } from "./ItemArchivedList.vue?vue&type=template&id=000935c1&"
import script from "./ItemArchivedList.vue?vue&type=script&lang=js&"
export * from "./ItemArchivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports